// annotation.title を受け取り、対応する grid plane の表示設定を返す純粋関数。
// プリセット外（'Custom'、未知、空文字）は null を返し、grid 自動切替を行わない。

export interface GridPlanes {
  XY: boolean;
  YZ: boolean;
  ZX: boolean;
}

const PRESET_MAP: Record<string, GridPlanes> = {
  px: { XY: false, YZ: true, ZX: false },
  mx: { XY: false, YZ: true, ZX: false },
  py: { XY: false, YZ: false, ZX: true },
  my: { XY: false, YZ: false, ZX: true },
  pz: { XY: true, YZ: false, ZX: false },
  mz: { XY: true, YZ: false, ZX: false },
  piso: { XY: true, YZ: false, ZX: false },
  miso: { XY: true, YZ: false, ZX: false },
  default: { XY: true, YZ: false, ZX: false },
};

export const gridPresetForAnnotation = (title: string): GridPlanes | null => {
  if (!title) return null;
  return PRESET_MAP[title.toLowerCase()] ?? null;
};
